import { createVuetify } from "vuetify";
import "vuetify/styles";

import { themes } from "@/assets/themes";
import { App } from "vue";
import { createRulesPlugin } from "vuetify/labs/rules";

const vuetify = createVuetify({
  theme: {
    defaultTheme: "base",
    themes: themes,
  },
  defaults: {
    VTextField: {
      color: "primary",
    },
    VTextarea: {
      color: "primary",
    },
    VSelect: {
      color: "primary",
    },
    VAutocomplete: {
      color: "primary",
    },
    VCombobox: {
      color: "primary",
    },
    VCheckbox: {
      color: "primary",
    },
    VRadio: {
      color: "primary",
    },
    VSwitch: {
      color: "primary",
    },
  },
});

export default function (app: App) {
  app.use(vuetify);

  const validation = createRulesPlugin({}, vuetify.locale);

  app.use(validation);
}
